import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .sluggable()
    .hasTitle()
    .hasSummary()
    .hasThumbnail()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

export default schema;
